import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import RetryRegular from './retry-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <RetryRegular {...validProps} />;
}
SvgComponent.iconName = 'retryRegular';

export const RetryRegularIcon = svgIconWrapper(SvgComponent);
